export interface PublishHistoryItem {
  label: string;
  type: WeathermakerForecastTypes;
  timestamp: string;
  status?: PublishHistoryStatus;
  output_artifact_url?: string;
  graphics_job_id?: number;
}

export enum PublishHistoryStatus {
  PROCESSING = 'processing',
  FAILED = 'failed',
  DOWNLOAD = 'download',
}

export interface SavedSourcesApiResponse {
  id: number;
  forecast_label: string;
  init_time: string;
  type: WeathermakerForecastTypes.WM_SAVED_SOURCE;
  start_date_utc: string;
  end_date_utc: string;
}

export interface SavedSourceData {
  site_id: string;
  valid_date: string;
  max_temp: number;
  min_temp: number;
}

export interface SaveAsSourceApiPayload {
  fcst_type: WeathermakerForecastTypes;
  rows: SavedSourceData[];
  region: string;
  fcst_name: string;
}

export enum WeathermakerForecastTypes {
  WM_SAVED_SOURCE = 'wm_saved_source',
  WM_IMPORTED_SOURCE = 'wm_imported_source',
  AG2_TRADER_FCST = 'ag2_trader_fcst',
  GRAPHICS_SOURCE = 'graphics_source',
  CSV = 'csv',
}

export interface ForecastMetaDataApiResponse {
  id: number;
  publishing_user: string;
  published_at: string;
  fcst_name: string;
  fcst_type: WeathermakerForecastTypes;
  region: string;
  job_status?: GraphicsJobStatus;
  output_artifact_url?: string;
  graphics_job_id?: number;
}

export interface SavedAsSourceApiResponse {
  success: boolean;
  message: string;
  id?: string;
  published_at: string;
  fcst_type: WeathermakerForecastTypes;
  job_status?: GraphicsJobStatus;
  output_artifact_url?: string;
  graphics_job_id?: number;
}

export interface CreateGraphicsDialogData {
  settings: GraphicsSettings;
  availableDays: Record<number, boolean>;
  availablePeriods: Record<string, boolean>;
}

export enum GraphicParameter {
  MIN_TEMP = 'MIN_TEMP',
  MAX_TEMP = 'MAX_TEMP',
  AVG_TEMP = 'AVG_TEMP',
}

export enum GraphicsJobStatus {
  PENDING = 'Pending',
  QUEUED = 'Queued',
  PROCESSING = 'Processing',
  COMPLETE = 'Complete',
  RETRYING = 'Retrying',
  FAILED = 'Failed',
}

export enum GraphicNormals {
  THIRTY_YEAR = '30_YEAR',
  TEN_YEAR = '10_YEAR',
}

export enum GraphicPointValue {
  NONE = 'NONE',
  TEMPERATURE = 'TEMPERATURE',
  DFN = 'DFN',
}

export enum GraphicRegion {
  NA_CONUS = 'NA_CONUS',
  NA_MIDWEST = 'NA_MIDWEST',
  NA_NORTHEAST = 'NA_NORTHEAST',
  NA_NORTHWEST = 'NA_NORTHWEST',
  NA_SOUTH_CENTRAL = 'NA_SOUTH_CENTRAL',
  NA_SOUTHEAST = 'NA_SOUTHEAST',
  NA_SOUTHWEST = 'NA_SOUTHWEST',
  EU = 'EU',
  EU_CENTRAL = 'EU_CENTRAL',
  EU_UK = 'EU_UK',
  EU_SCANDANAVIA = 'EU_SCANDINAVIA',
  EU_SOUTHEAST = 'EU_SOUTHEAST',
}
export enum ForecastPeriod {
  DAYS_1_5 = '1-5 Day',
  DAYS_6_10 = '6-10 Day',
  DAYS_11_15 = '11-15 Day',
  DAYS_1_7 = '1-7 Day',
  DAYS_8_14 = '8-14 Day',
}

export enum CalendarWeekPeriod {
  CALENDAR_WEEK_1 = 'Calendar Week 1',
  CALENDAR_WEEK_2 = 'Calendar Week 2',
  CALENDAR_WEEK_3 = 'Calendar Week 3',
}

export type GraphicsPeriod = ForecastPeriod | CalendarWeekPeriod;

export enum UnitsEnum {
  DEG_F = 'degF',
  DEG_C = 'degC',
}

export enum DfnNormalsPeriodEnum {
  TEN = '10',
  THIRTY = '30',
}

export interface GraphicsSettings {
  parameters: GraphicParameter[];
  contour_anomalies: GraphicNormals;
  plot_values_enabled: boolean;
  plot_values: GraphicPointValue | null;
  fcst_days: number[];
  periods: GraphicsPeriod[];
  regions: GraphicRegion[];
  units_enum?: UnitsEnum;
  display_timestamp_tz?: string;
  degC_decimals?: boolean;
}

export interface CreateGraphicsApiPayload {
  fcst_name: string;
  region: string;
  rows: SavedSourceData[];
  period_rows: PeriodForecastRow[];
  graphics: GraphicsSettings;
}

export interface Option<T = string> {
  label: string;
  value: T;
}

export interface PeriodForecastRow {
  site_id: string;
  period: GraphicsPeriod;
  period_valid_start: Date;
  period_valid_end: Date;
  min_temp?: number;
  max_temp?: number;
  avg_temp?: number;
  min_temp_dfn?: number;
  max_temp_dfn?: number;
  avg_temp_dfn?: number;
  dfn_normals_period: DfnNormalsPeriodEnum;
}
